import { recaptchaV2ConfigValidator } from '../recaptcha-v2/types/config';
export const captchaConfigValidator = recaptchaV2ConfigValidator;
